import React from 'react';

/**
 * Componente para indicadores de paginação de recursos na timeline
 * Design inspirado no estilo Instagram/X para uma experiência moderna
 * 
 * @param {Object} props - Propriedades do componente
 * @param {number} props.totalCount - Número total de recursos
 * @param {number} props.visibleCount - Número de recursos visíveis por página
 * @param {number} props.startIndex - Índice inicial dos recursos visíveis
 * @param {Function} props.onPageChange - Função chamada quando a página é alterada
 * @returns {JSX.Element} - Componente React
 */
const ResourcePagination = ({
  totalCount,
  visibleCount,
  startIndex,
  onPageChange
}) => {
  // Calcular o número total de páginas
  const pageCount = Math.ceil(totalCount / visibleCount);
  
  // Calcular a página atual baseado no índice inicial
  const currentPage = Math.floor(startIndex / visibleCount);
  
  // Se temos apenas uma página, não mostrar nada
  if (pageCount <= 1) return null;
  
  return (
    <div className="flex justify-center items-center gap-1 mt-2 mb-2">
      {Array.from({ length: pageCount }).map((_, idx) => (
        <button
          key={idx}
          className={`w-1.5 h-1.5 rounded-full transition-all duration-200 transform 
            ${idx === currentPage 
              ? 'bg-blue-500 scale-110' 
              : 'bg-gray-300 hover:bg-gray-400'
            }`}
          onClick={() => onPageChange(idx * visibleCount)}
          aria-label={`Ir para página ${idx + 1} de ${pageCount}`}
          title={`Página ${idx + 1}`}
        />
      ))}
    </div>
  );
};

export default ResourcePagination; 